"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _map = _interopRequireDefault(require("transmute/map"));

var _get = _interopRequireDefault(require("transmute/get"));

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _always = _interopRequireDefault(require("transmute/always"));

var _ifElse = _interopRequireDefault(require("transmute/ifElse"));

var _enviro = _interopRequireDefault(require("enviro"));

var checkPropTypes = function checkPropTypes(propTypes, props, componentName) {
  var error; // Re-purposing to maintain the contract of throwing for prop type errors

  var getStack = function getStack() {
    error = true; // Don't throw here to allow console error to log

    return '';
  };

  Object.keys(props).forEach(function (key) {
    var propType = propTypes[key];

    if (propType == null) {
      var keys = Object.keys(propTypes).map(function (key) {
        return "`" + key + "`";
      }).join(', ');
      throw new Error("Unexpected prop `" + key + "` supplied to `" + componentName + "`, expected props to be " + keys);
    } // React v15 compatible


    if (_propTypes.default.checkPropTypes) {
      _propTypes.default.checkPropTypes(propTypes, props, key, componentName, getStack);
    }

    if (error) {
      throw new Error("Invalid prop `" + key + "` supplied to `" + componentName + "`");
    }
  });
};

var TypedRecord = function TypedRecord(recordDefinition) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'TypedRecord';
  var defaults = (0, _map.default)((0, _ifElse.default)(_isFunction.default, (0, _always.default)(undefined), (0, _get.default)('default')), recordDefinition);
  var propTypes = (0, _map.default)((0, _ifElse.default)(_isFunction.default, _identity.default, (0, _get.default)('type')), recordDefinition);
  var RecordClass = (0, _immutable.Record)(defaults, name);

  if (_enviro.default.deployed() && _enviro.default.isProd()) {
    return RecordClass;
  }

  var check = function check(record) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    checkPropTypes(propTypes, (0, _extends2.default)({}, values, record.toObject()), name);
  };

  function TypedRecordClass(values) {
    if (!(this instanceof TypedRecordClass)) {
      return new TypedRecordClass(values);
    }

    RecordClass.call(this, values);
    check(this, values);
    return this;
  }

  TypedRecordClass.prototype = Object.create(RecordClass.prototype, {
    constructor: {
      value: TypedRecordClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(TypedRecordClass, TypedRecord);
  } else {
    TypedRecordClass.__proto__ = TypedRecord;
  }

  TypedRecordClass.prototype.set = function (key, value) {
    var result = RecordClass.prototype.set.call(this, key, value);
    check(result, (0, _defineProperty2.default)({}, key, value));
    return result;
  };

  Object.defineProperty(TypedRecordClass, 'name', {
    value: name
  });
  return TypedRecordClass;
};

var _default = TypedRecord;
exports.default = _default;
module.exports = exports.default;